var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.875 19.9062H6.125C2.26625 19.9062 1.09375 18.7337 1.09375 14.875V6.125C1.09375 2.26625 2.26625 1.09375 6.125 1.09375H7.4375C8.96875 1.09375 9.45 1.5925 10.0625 2.40625L11.375 4.15625C11.6637 4.54125 11.7075 4.59375 12.25 4.59375H14.875C18.7337 4.59375 19.9062 5.76625 19.9062 9.625V14.875C19.9062 18.7337 18.7337 19.9062 14.875 19.9062ZM6.125 2.40625C3.00125 2.40625 2.40625 3.00125 2.40625 6.125V14.875C2.40625 17.9988 3.00125 18.5938 6.125 18.5938H14.875C17.9988 18.5938 18.5938 17.9988 18.5938 14.875V9.625C18.5938 6.50125 17.9988 5.90625 14.875 5.90625H12.25C11.13 5.90625 10.7625 5.52125 10.325 4.94375L9.0125 3.19375C8.5575 2.59 8.42625 2.40625 7.4375 2.40625H6.125Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.caa35be6.svg";
export { ForwardRef as ReactComponent };